import React, { useMemo } from 'react';

import { useBreakpoints } from 'hooks/useBreakpoints';
import { useDCS } from 'hooks/useDCS';
import type { Bundles, Solution } from 'services/cms/bundleTypes';
import { PricingTable } from './PricingTable/PricingTable';
import { PricingTableWithTabs } from './PricingTableWithTabs/PricingTableWithTabs';
import type { FeaturesByCategories } from './types';
import { decorateBundlesFeatures, filterBundlesWithFeatureValues, mapBundleAgainstPricings } from './utils';
import { BooleanFilter } from 'utils/TypeUtils';

interface IPricingDetailTableProps {
  solution: Solution;
}

export const PricingDetailTable: React.FC<IPricingDetailTableProps> = ({ solution }) => {
  const { bundles = [], showTag, tagText, tagBackgroundColor, bundleWithTag, title } = solution;

  const bundleIds = useMemo(() => {
    return bundles
      .filter(bundle => bundle.dcsId)
      .map(bundle => bundle.dcsId)
      .filter(BooleanFilter);
  }, [bundles]);

  const { browser } = useBreakpoints();
  const isDesktopOrLarge = browser.is.desktop;
  const { bundlesPricings } = useDCS({ bundleIds });

  if (!bundles.length) return null;

  const formattedBundles: Bundles = filterBundlesWithFeatureValues(bundles);
  const categoriesWithFeatures: FeaturesByCategories = decorateBundlesFeatures(bundles);
  const sortedPricingsData = mapBundleAgainstPricings(bundles, bundlesPricings);

  const props = {
    bundles: formattedBundles,
    categoriesWithFeatures,
    showTag,
    tagText,
    tagBackgroundColor,
    bundleWithTag,
    bundlesPricings: sortedPricingsData,
    solutionTitle: title,
  };

  return isDesktopOrLarge ? <PricingTable {...props} /> : <PricingTableWithTabs {...props} />;
};
